import styled from 'styled-components';
import { Flex } from '@amzn/storm-ui';

export const UserManagementFlex = styled(Flex)`
  justify-content: space-between;
  padding: 0 0 1rem 0;
`;

export const DataTableActionsFlex = styled(Flex)`
  justify-content: space-evenly;
`;

export const NoDataFoundContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0.5rem;
`;

export const LeftAlignedErrorContainer = styled.div`
  margin-top: 1rem;

  && > div {
    margin: 0;
    padding: 1rem;
    justify-content: flex-start;
  }
`;
